export const confirmEmailPage = () =>
  import("./ConfirmEmailPage").then((m) => ({ Component: m.ConfirmEmailPage }));
